import axios from 'axios'
import { UrlApi, authMail, authPass } from '../Keys'
import { toast } from "react-toastify"
import moment from "moment"

const dataInicial = {
    proyectosInvestigacion: [],
    loadingProyectos: false,
    productos: [],
    loadingProductos: false,
    revistas: [],
    loadingRevistas: false,
    presentaciones: [],
    loadingPresentaciones: false,
    titulos: [],
    loadingTitulos: false,
    desarrollos: [],
    loadingDesarrollos: false,
    creacion: '',
    creacionId: '',
    modificacion: ''
}

const LOADING_PROYECTOS_INVESTIGACION = 'LOADING_PROYECTOS_INVESTIGACION'
const PROYECTOS_INVESTIGACION = 'PROYECTOS_INVESTIGACION'
const PROYECTOS_INVESTIGACION_ERROR = 'PROYECTOS_INVESTIGACION_ERROR'


const LOADING_PRODUCTOS = 'LOADING_PRODUCTOS'
const PRODUCTOS = 'PRODUCTOS'
const PRODUCTOS_ERROR = 'PRODUCTOS_ERROR'


const LOADING_REVISTAS = 'LOADING_REVISTAS'
const REVISTAS = 'REVISTAS'
const REVISTAS_ERROR = 'REVISTAS_ERROR'


const LOADING_PRESENTACIONES = 'LOADING_PRESENTACIONES'
const PRESENTACIONES = 'PRESENTACIONES'
const PRESENTACIONES_ERROR = 'PRESENTACIONES_ERROR'


const LOADING_TITULOS = 'LOADING_TITULOS'
const TITULOS = 'TITULOS'
const TITULOS_ERROR = 'TITULOS_ERROR'


const LOADING_DESARROLLOS = 'LOADING_DESARROLLOS'
const DESARROLLOS = 'DESARROLLOS'
const DESARROLLOS_ERROR = 'DESARROLLOS_ERROR'

const CREAR_EXITO = 'CREAR_EXITO'
const CREAR_ERROR = 'CREAR_ERROR'

const MODIFICAR_EXITO = 'MODIFICAR_EXITO'
const MODIFICAR_ERROR = 'MODIFICAR_ERROR'

//Reducers
export default function investigacionReducer(state = dataInicial, action) {
    switch (action.type) {
        case MODIFICAR_EXITO:
            return { ...state, modificacion: action.modificacion }
        case MODIFICAR_ERROR:
            return { ...state, modificacion: action.modificacion }
        case PROYECTOS_INVESTIGACION:
            return { ...state, proyectosInvestigacion: action.payload, loadingProyectos: action.loadingProyectos }
        case LOADING_PROYECTOS_INVESTIGACION:
            return { ...state, loadingProyectos: action.loadingProyectos }
        case CREAR_EXITO:
            return { ...state, creacionId: action.payload, creacion: action.creacion }
        case PRODUCTOS:
            return { ...state, productos: action.payload, loadingProductos: action.loadingProductos }
        case LOADING_PRODUCTOS:
            return { ...state, loadingProductos: action.loadingProductos }
        case REVISTAS:
            return { ...state, revistas: action.payload, loadingRevistas: action.loadingRevistas }
        case LOADING_REVISTAS:
            return { ...state, loadingRevistas: action.loadingRevistas }
        case PRESENTACIONES:
            return { ...state, presentaciones: action.payload, loadingPresentaciones: action.loadingPresentaciones }
        case LOADING_PRESENTACIONES:
            return { ...state, loadingPresentaciones: action.loadingPresentaciones }
        case TITULOS:
            return { ...state, titulos: action.payload, loadingTitulos: action.loadingTitulos }
        case LOADING_TITULOS:
            return { ...state, loadingTitulos: action.loadingTitulos }
        case DESARROLLOS:
            return { ...state, desarrollos: action.payload, loadingDesarrollos: action.loadingDesarrollos }
        case LOADING_DESARROLLOS:
            return { ...state, loadingDesarrollos: action.loadingDesarrollos }
        default:
            return { ...state }
    }
}

export const proyectosInvestigacion = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_PROYECTOS_INVESTIGACION,
        loadingProyectos: true
    })

    try {
        var entidad = "new_proyectosdeinvestigacins"
        var fetch =
            "<entity name='new_proyectosdeinvestigacin'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='new_fechadeinicio'/>" +
            "<attribute name='new_fechadefinalizacin'/>" +
            "<attribute name='new_carcterdelaparticipcin'/>" +
            "<attribute name='new_institucionfinanciadora'/>" +
            "<attribute name='new_institucionevaluadora'/>" +
            "<attribute name='new_institucion'/>" +
            "<attribute name='new_proyectosdeinvestigacinid'/>" +
            "<order attribute='new_fechadeinicio' descending='true'/>" +
            "<order attribute='new_name' descending='false'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='aj'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: PROYECTOS_INVESTIGACION,
            payload: response.data,
            loadingProyectos: false
        })
    }
    catch (error) {
        dispatch({
            type: PROYECTOS_INVESTIGACION_ERROR,
            loadingProyectos: false
        })
    }
}

export const productos = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_PRODUCTOS,
        loadingProductos: true
    })

    try {
        var entidad = "new_publicacionenrevistas" // Rellenar con la entidad para productos
        var fetch =
            "<entity name='new_publicacionenrevista'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='new_volumen'/>" +
            "<attribute name='new_revista'/>" +
            "<attribute name='new_paginas'/>" +
            "<attribute name='new_fechadepublicacin'/>" +
            "<attribute name='new_autores'/>" +
            "<attribute name='new_publicacionenrevistaid'/>" +
            "<order attribute='new_fechadepublicacin' descending='true'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "<condition attribute='new_conarbitraje' operator='eq' value='1'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='al'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: PRODUCTOS,
            payload: response.data,
            loadingProductos: false
        })
    }
    catch (error) {
        dispatch({
            type: PRODUCTOS_ERROR,
            loadingProductos: false
        })
    }
}

export const revistas = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_REVISTAS,
        loadingRevistas: true
    })

    try {
        var entidad = "new_publicacionenrevistas"
        var fetch =
            "<entity name='new_publicacionenrevista'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='new_volumen'/>" +
            "<attribute name='new_revista'/>" +
            "<attribute name='new_paginas'/>" +
            "<attribute name='new_fechadepublicacin'/>" +
            "<attribute name='new_autores'/>" +
            "<attribute name='new_publicacionenrevistaid'/>" +
            "<attribute name='new_conarbitraje'/>" +
            "<order attribute='new_fechadepublicacin' descending='true'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            // "<condition attribute='new_conarbitraje' operator='eq' value='0'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='ak'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: REVISTAS,
            payload: response.data,
            loadingRevistas: false
        })
    }
    catch (error) {
        dispatch({
            type: REVISTAS_ERROR,
            loadingRevistas: false
        })
    }
}

export const presentaciones = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_PRESENTACIONES,
        loadingPresentaciones: true
    })

    try {
        var entidad = "new_presentacinacongresosseminarioses"
        var fetch = 
            "<entity name='new_presentacinacongresosseminarios'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='new_lugarderealizacin'/>" +
            "<attribute name='new_fechaderealizacin'/>" +
            "<attribute name='new_evento'/>" +
            "<attribute name='new_autores'/>" +
            "<attribute name='new_presentacinacongresosseminariosid'/>" +
            "<order attribute='new_fechaderealizacin' descending='true'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='am'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: PRESENTACIONES,
            payload: response.data,
            loadingPresentaciones: false
        })
    }
    catch (error) {
        dispatch({
            type: PRESENTACIONES_ERROR,
            loadingPresentaciones: false
        })
    }
}

export const titulos = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_TITULOS,
        loadingTitulos: true
    })

    try {
        var entidad = "new_ttulodepropiedadintelectuals"
        var fetch =
            "<entity name='new_ttulodepropiedadintelectual'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='new_titular'/>" +
            "<attribute name='new_fechasolicitud'/>" +
            "<attribute name='new_fechaotorgamiento'/>" +
            "<attribute name='new_ttulodepropiedadintelectualid'/>" +
            "<order attribute='new_name' descending='false'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: TITULOS,
            payload: response.data,
            loadingTitulos: false
        })
    }
    catch (error) {
        dispatch({
            type: TITULOS_ERROR,
            loadingTitulos: false
        })
    }
}

export const desarrollos = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_DESARROLLOS,
        loadingDesarrollos: true
    })

    try {
        var entidad = "new_desarrollonopasiblepropiedadintelectuals"
        var fetch =
            "<entity name='new_desarrollonopasiblepropiedadintelectual'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='new_descripcion'/>" +
            "<attribute name='new_desarrollonopasiblepropiedadintelectualid'/>" +
            "<order attribute='new_name' descending='false'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: DESARROLLOS,
            payload: response.data,
            loadingDesarrollos: false
        })
    }
    catch (error) {
        dispatch({
            type: DESARROLLOS_ERROR,
            loadingDesarrollos: false
        })
    }
}

export const crearProyecto = (empleado, objeto, token) => async (dispatch) => {
    const { new_name, new_fechadeinicio, new_fechadefinalizacin, _new_institucion_value, _new_institucionevaluadora_value, _new_institucionfinanciadora_value,
        new_carcterdelaparticipcin, new_principalesresultados } = objeto;


    return toast.promise(
        new Promise((resolve, reject) => {
            axios.post(
                `${UrlApi}api/hrfactors/proyectodeinvestigacion`,
                {
                    "new_name": new_name,
                    "new_empleado": empleado,
                    "new_fechadeinicio": moment(new_fechadeinicio).format('YYYY-MM-DD'),
                    "new_fechadefinalizacin": moment(new_fechadefinalizacin).format('YYYY-MM-DD'),
                    "new_institucion": _new_institucion_value.value,
                    "new_institucionevaluadora": _new_institucionevaluadora_value.value,
                    "new_institucionfinanciadora": _new_institucionfinanciadora_value.value,
                    // "new_experienciaenpi": true,
                    "new_carcterdelaparticipcin": new_carcterdelaparticipcin,
                    // "new_division": "string",
                    // "new_metaria": "string",
                    // "new_matriz": "string",
                    "new_principalesresultados": new_principalesresultados
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: CREAR_EXITO,
                        payload: response.data,
                        creacion: "EXITO",
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: CREAR_ERROR,
                        creacion: "ERROR",
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Proyecto creado con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};

export const crearPublicacionRevista = (empleado, objeto, token) => async (dispatch) => {
    const {
        new_conarbitraje,
        new_name,
        new_autores,
        new_revista,
        new_fechadepublicacin,
        new_volumen,
        new_paginas,
        new_sitiowebconinformacin,
        new_palabrasclave,
    } = objeto;


    return toast.promise(
        new Promise((resolve, reject) => {
            axios.post(
                `${UrlApi}api/hrfactors/publicacionenrevista`,
                {
                    "new_conarbitraje": new_conarbitraje,
                    "new_empleado": empleado,
                    "new_name": new_name,
                    "new_autores": new_autores,
                    "new_revista": new_revista,
                    // "new_formacindocenteasociadasicorresponde": "string",
                    "new_fechadepublicacin": moment(new_fechadepublicacin).format('YYYY-MM-DD'),
                    "new_volumen": new_volumen,
                    "new_paginas": new_paginas,
                    "new_sitiowebconinformacin": new_sitiowebconinformacin,
                    "new_palabrasclave": new_palabrasclave
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: CREAR_EXITO,
                        payload: response.data,
                        creacion: "EXITO",
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: CREAR_ERROR,
                        creacion: "ERROR",
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Proyecto creado con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};

export const crearPresentacionAcongresos = (empleado, objeto, token) => async (dispatch) => {
    const {
        new_autores,
        new_name,
        new_evento,
        new_lugarderealizacin,
        new_fechaderealizacin,
        new_sitiowebconinformacin,
        new_palabrasclave,
    } = objeto;


    return toast.promise(
        new Promise((resolve, reject) => {
            axios.post(
                `${UrlApi}api/hrfactors/presentacionacongresos`,
                {
                    "new_autores": new_autores,
                    "new_name": new_name,
                    "new_evento": new_evento,
                    "new_lugarderealizacin": new_lugarderealizacin,
                    "new_fechaderealizacin": moment(new_fechaderealizacin).format('YYYY-MM-DD'),
                    "new_sitiowebconinformacin": new_sitiowebconinformacin,
                    "new_palabrasclave": new_palabrasclave,
                    "new_empleado": empleado
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: CREAR_EXITO,
                        payload: response.data,
                        creacion: "EXITO",
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: CREAR_ERROR,
                        creacion: "ERROR",
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Presentacion creada con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};

export const crearTituloPropiedad = (empleado, objeto, token) => async (dispatch) => {
    const {
        new_name,
        new_titular,
        new_fechasolicitud,
        new_fechaotorgamiento,
    } = objeto;


    return toast.promise(
        new Promise((resolve, reject) => {
            axios.post(
                `${UrlApi}api/hrfactors/titulodepropiedad`,
                {
                    "new_name": new_name,
                    "new_titular": new_titular,
                    "new_fechasolicitud": moment(new_fechasolicitud).format('YYYY-MM-DD'),
                    "new_fechaotorgamiento": moment(new_fechaotorgamiento).format('YYYY-MM-DD'),
                    "new_empleado": empleado
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: CREAR_EXITO,
                        payload: response.data,
                        creacion: "EXITO",
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: CREAR_ERROR,
                        creacion: "ERROR",
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Titulo de propiedad creado con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};

export const crearDesarrollos = (empleado, objeto, token) => async (dispatch) => {
    const {
        new_name,
        new_descripcion,
    } = objeto;


    return toast.promise(
        new Promise((resolve, reject) => {
            axios.post(
                `${UrlApi}api/hrfactors/desarrollonopasible`,
                {
                    "new_name": new_name,
                    "new_descripcion": new_descripcion,
                    "new_empleado": empleado
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: CREAR_EXITO,
                        payload: response.data,
                        creacion: "EXITO",
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: CREAR_ERROR,
                        creacion: "ERROR",
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Desarrollo no pasible creado con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};

export const actualizarInvestigacion = (empleado, valor1, valor2, token) => async (dispatch) => {


    return toast.promise(
        new Promise((resolve, reject) => {
            axios.put(
                `${UrlApi}api/hrfactors/areaacademica`,
                {
                    "new_empleadoid": empleado,
                    "new_conicet": valor1,
                    "new_programade": valor2
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: MODIFICAR_EXITO,
                        payload: response.data,
                        modificacion: "EXITO",
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: MODIFICAR_ERROR,
                        modificacion: "ERROR",
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Actualizado con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};